module.exports = __webpack_public_path__ + "static/media/step-1.bc31d9c5.svg";